export enum OrganizationType {
  CONSUMER_BANKRUPTCY = 'Consumer Bankruptcy',
  COMMERCIAL_BANKRUPTCY = 'Commercial Bankruptcy',
  CHAPTER_13_TRUSTEE = 'Chapter 13 Trusteeship',
  CREDITOR_REPRESENTATION_IN_BANKRUPTCY = 'Creditor Representation in Bankruptcy',
  PROBATE_AND_ESTATE_PRACTITIONER = 'Probate & Estate',
  CIVIL_LITIGATION = 'Civil Litigation',
  FAMILY_LAW = 'Family Law',
  IMMIGRATION_LAW = 'Immigration Law',
  TRUSTEE_COMPANY = 'Trustee Company',
  MORTGAGE_SERVICER = 'Mortgage Servicer',
  DEBT_COLLECTOR = 'Debt Collector',
  PROPERTY_MANAGER = 'Property Manager',
  OTHER = 'Other'
}
